/**
 * 图片滤镜插件多编辑器状态
 *
 * Store 由插件注册系统按 identity 创建，只供控制器读写；UI 通过插件事件接收快照。
 */
import { create, type StoreApi, type UseBoundStore } from 'zustand';
import { getState } from '@/framework';
import type { IExportState, StateType } from '@/version-types';
import type { IImageFilterUISnapshot } from './types';

/** 图片滤镜初始 UI 快照。 */
export const INITIAL_IMAGE_FILTER_SNAPSHOT: IImageFilterUISnapshot = {
    layerId: '',
    filter: null,
    alpha: 1,
    status: 'idle',
    hasPendingChanges: false,
    isPreviewing: false,
    error: '',
};

interface IImageFilterStore {
    snapshot: IImageFilterUISnapshot;
    setSnapshot: (snapshot: IImageFilterUISnapshot) => void;
}

const name = 'image-filter-state';
type ModuleType = StateType<IImageFilterStore, typeof name>;

const createState = () =>
    create<IImageFilterStore>((set) => ({
        snapshot: INITIAL_IMAGE_FILTER_SNAPSHOT,
        setSnapshot(snapshot) {
            set({ snapshot });
        },
    }));

/**
 * 获取指定编辑器的图片滤镜 Store
 *
 * @param identity - 编辑器实例标识
 * @returns 图片滤镜 Zustand Store
 */
export const getImageFilterStore = (identity: string): UseBoundStore<StoreApi<IImageFilterStore>> =>
    getState<ModuleType>(identity)[name];

/** 图片滤镜插件状态注册描述。 */
const imageFilterState: IExportState = {
    name,
    createState,
};

export default imageFilterState;
